import(/* webpackMode: "eager", webpackExports: ["MessagesLayer"] */ "/vercel/path0/components/i18n/MessagesLayer.tsx");
